import {
    apiURL,
    baseURL,
    sentryUrl,
    imageBaseURL,
    xFunctionsKey,
    ocpApimSubscriptionKey,
} from 'helpers/config';

const params = {
    development: {
        apiUrl: apiURL + `/api/v1`,
        baseUrl: baseURL,
        imageBaseURL: imageBaseURL,
        xFunctionsKey: xFunctionsKey,
        ocpApimSubscriptionKey: ocpApimSubscriptionKey,
        sentryUrl: sentryUrl,
    },
    staging: {
        apiUrl: apiURL,
        baseUrl: baseURL,
        imageBaseURL: imageBaseURL,
        xFunctionsKey: xFunctionsKey,
        ocpApimSubscriptionKey: ocpApimSubscriptionKey,
        sentryUrl: sentryUrl,
    },
    production: {
        apiUrl: apiURL,
        baseUrl: baseURL,
        imageBaseURL: imageBaseURL,
        xFunctionsKey: xFunctionsKey,
        ocpApimSubscriptionKey: ocpApimSubscriptionKey,
        sentryUrl: sentryUrl,
    }
};

export default params[process.env.NODE_ENV || 'development'];
